module.exports = __webpack_public_path__ + "static/media/audit-log-logo.51758c49.png";